<div class="container">
  @if (title) {
    <h2>{{ title }}</h2>
  }
  @if (subtitle) {
    <p>{{ subtitle }}</p>
  }

  <div class="buttons">
    @for (button of buttons; track button) {
      <button mat-raised-button (click)="buttonClicked(button)">
        {{ button }}
      </button>
    }
  </div>
</div>
